import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { jumpToSectionId } from "@Components/Modules/Helpers";

let isFirstLoad = true;
let maxAttempt = 2;

export default function HashNavigation() {
    const { pathname, hash } = useLocation();
    const timeoutRef = useRef<number>(0);

    const scroll = (hash: string) => {
        timeoutRef.current = window.setTimeout(
            (h: string) => {
                const element = document.getElementById(h);
                if (!element && maxAttempt !== 0) {
                    maxAttempt -= 1;
                    scroll(h);
                } else {
                    jumpToSectionId(h, true, 0, "instant");
                }
            },
            350,
            hash,
        );
    };

    useEffect(() => {
        if (isFirstLoad && !hash) {
            isFirstLoad = false;
            return;
        }

        if (hash) {
            scroll(hash.substring(1));
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }

        return () => {
            window.clearTimeout(timeoutRef.current);
        };
    }, [pathname, hash]);

    return null as React.ReactNode;
}
